<!-- Imperial Solutions Invoice Format -->
<div class="imperial-invoice-container">
  <div class="invoice-page" *ngFor="let invoice of editableInvoices; let i = index; trackBy: trackByInvoiceIndex">

    <!-- Header Section -->
    <div class="invoice-header">
      <div class="company-logo-section">
        <div class="logo-circle">
          <img *ngIf="logoUrl" [src]="logoUrl" alt="Logo"
            style="width: 100%; height: 100%; object-fit: contain;">
          <span *ngIf="!logoUrl" class="logo-text">SMJ</span>
        </div>
      </div>

      <div class="company-details">
        <h2 class="company-name">{{ settings?.company }}</h2>
        <div class="company-address">
          <p>{{ settings?.city }}, {{ settings?.state }}, JAPAN</p>
          <p><strong>TEL:</strong> {{ settings?.telephone }} <strong>FAX:</strong> {{ settings?.fax }}</p>
          <p><strong>E-MAIL:</strong> {{ settings?.email_1 }}</p>
        </div>
      </div>
    </div>

    <!-- Invoice Title -->
    <div class="invoice-title">
      <h1>INVOICE</h1>
    </div>

    <!-- Main Content Grid -->
    <div class="invoice-content">

      <!-- Left Column -->
      <div class="left-column">

        <!-- Consignee Section -->
        <div class="section consignee-section">
          <div class="section-header">CONSIGNEE:</div>
          <div class="section-content">
            <p><strong>{{ invoice.order?.buyer_company_name || invoice.order?.buyer_consignee_name }}</strong></p>
            <p>{{ invoice.order?.buyer_street_address }}</p>
            <p>{{ invoice.order?.buyer_city }}</p>
            <p>{{ invoice.order?.buyer_country }}</p>
            <p>{{ invoice.order?.buyer_email_address }}</p>
            <p><strong>TEL:</strong> {{ invoice.order?.buyer_telephone_no }}</p>
          </div>
        </div>

        <!-- Notify Party Section -->
        <div class="section notify-section">
          <div class="section-header">NOTIFY PARTY:</div>
          <div class="section-content">
            <p><strong>{{ invoice.order?.buyer_company_name || invoice.order?.buyer_consignee_name }}</strong></p>
            <p>{{ invoice.order?.buyer_street_address }}</p>
            <p>{{ invoice.order?.buyer_city }}</p>
            <p>{{ invoice.order?.buyer_country }}</p>
          </div>
        </div>

        <!-- Port Information -->
        <div class="port-info">
          <div class="port-section">
            <div class="section-header">PORT OF LOADING:</div>
            <div class="section-content">
              <p><strong>
                <input type="text" class="form-control form-control-sm port-input"
                  [(ngModel)]="invoice.editablePortOfLoading"
                  (ngModelChange)="onFieldChange()">
              </strong></p>
            </div>
          </div>

          <div class="port-section">
            <div class="section-header">PORT OF DISCHARGING:</div>
            <div class="section-content">
              <p><strong>
                <input type="text" class="form-control form-control-sm port-input"
                  [(ngModel)]="invoice.editablePortOfDischarging"
                  (ngModelChange)="onFieldChange()">
              </strong></p>
            </div>
          </div>
        </div>

        <!-- Shipping Details -->
        <div class="shipping-details">
          <div class="detail-row">
            <span class="label">SHIPPED PER:</span>
            <span class="value">
              <input type="text" class="form-control form-control-sm shipping-input"
                [(ngModel)]="invoice.editableShipperPer"
                (ngModelChange)="onFieldChange()">
            </span>
          </div>

          <div class="detail-row">
            <span class="label">VOYAGE NO:</span>
            <span class="value">
              <input type="text" class="form-control form-control-sm shipping-input"
                [(ngModel)]="invoice.editableVoyageNo"
                (ngModelChange)="onFieldChange()">
            </span>
          </div>

          <div class="detail-row">
            <span class="label">ESTIMATED TIME OF DEPARTURE:</span>
            <span class="value">
              <input type="text" class="form-control form-control-sm shipping-input"
                [(ngModel)]="invoice.editableETD"
                (ngModelChange)="onFieldChange()"
                placeholder="DD-MMM-YYYY">
            </span>
          </div>

          <div class="detail-row">
            <span class="label">ESTIMATED TIME OF ARRIVAL:</span>
            <span class="value">
              <input type="text" class="form-control form-control-sm shipping-input"
                [(ngModel)]="invoice.editableETA"
                (ngModelChange)="onFieldChange()"
                placeholder="DD-MMM-YYYY">
            </span>
          </div>
        </div>

      </div>

      <!-- Right Column -->
      <div class="right-column">

        <!-- Invoice Details -->
        <div class="invoice-details-section">
          <div class="detail-row">
            <span class="label">INVOICE NO:</span>
            <span class="value"><strong>{{ invoice.invoice_number }}</strong></span>
          </div>

          <div class="detail-row">
            <span class="label">DATE:</span>
            <span class="value"><strong>{{ invoice.invoice_date ? formatDate(invoice.invoice_date) : '-' }}</strong></span>
          </div>
        </div>

        <!-- Bank Details -->
        <div class="section bank-section">
          <div class="section-header">BANK DETAILS:</div>
          <div class="section-content">
            <p><strong>BANK NAME:</strong>
              <input type="text" class="form-control form-control-sm bank-input"
                [(ngModel)]="invoice.editableBankName"
                (ngModelChange)="onFieldChange()">
            </p>
            <p><strong>BRANCH NAME:</strong>
              <input type="text" class="form-control form-control-sm bank-input"
                [(ngModel)]="invoice.editableBranchName"
                (ngModelChange)="onFieldChange()">
            </p>
            <p><strong>ACCOUNT NAME:</strong>
              <input type="text" class="form-control form-control-sm bank-input bank-input-wide"
                [(ngModel)]="invoice.editableAccountName"
                (ngModelChange)="onFieldChange()">
            </p>
            <p><strong>ACCOUNT NO:</strong>
              <input type="text" class="form-control form-control-sm bank-input bank-input-narrow"
                [(ngModel)]="invoice.editableAccountNo"
                (ngModelChange)="onFieldChange()">
            </p>
            <p><strong>SWIFT CODE:</strong>
              <input type="text" class="form-control form-control-sm bank-input bank-input-narrow"
                [(ngModel)]="invoice.editableSwiftCode"
                (ngModelChange)="onFieldChange()">
            </p>
          </div>
        </div>

        <!-- Ship Type and Terms -->
        <div class="terms-section">
          <div class="detail-row">
            <span class="label">SHIP TYPE:</span>
            <span class="value">
              <input type="text" class="form-control form-control-sm terms-input"
                [(ngModel)]="invoice.editableShipType"
                (ngModelChange)="onFieldChange()">
            </span>
          </div>

          <div class="detail-row">
            <span class="label">TRADE TERMS:</span>
            <span class="value">
              <input type="text" class="form-control form-control-sm terms-input"
                [(ngModel)]="invoice.editableTradeTerms"
                (ngModelChange)="onFieldChange()">
            </span>
          </div>

          <div class="detail-row">
            <span class="label">PAYMENT TERMS:</span>
            <span class="value">
              <input type="text" class="form-control form-control-sm terms-input terms-input-wide"
                [(ngModel)]="invoice.editablePaymentTerms"
                (ngModelChange)="onFieldChange()">
            </span>
          </div>
        </div>

        <!-- Destination -->
        <div class="destination-section">
          <div class="detail-row">
            <span class="label">C&F:</span>
            <span class="value"><strong>
              <input type="text" class="form-control form-control-sm destination-input"
                [(ngModel)]="invoice.editableCAndF"
                (ngModelChange)="onFieldChange()">
            </strong></span>
          </div>
        </div>

      </div>
    </div>

    <!-- Vehicle Details Section -->
    <div class="vehicle-section">
      <div class="vehicle-header">
        <div class="make-model">
          <span class="label">MAKE SMALL:</span>
          <span class="value">{{ viewMode === 'merged' && invoice.vehicles ? 'MULTIPLE VEHICLES' : invoice.vehicle?.make }}</span>
        </div>

        <div class="vehicle-details-header">
          <span class="label">VEHICLE DETAILS:</span>
        </div>

        <div class="cost-calculation">
          <span class="label">COST CALCULATION (S)</span>
        </div>
      </div>

      <!-- Individual Vehicle Mode -->
      <div class="vehicle-content" *ngIf="(viewMode !== 'merged' || !invoice.editableVehicles) && invoice.editableVehicle">
        <!-- Vehicle Image -->
        <div class="vehicle-image">
          <img
            [src]="invoice.editableVehicle?.pictures && invoice.editableVehicle.pictures.length > 0 ? invoice.editableVehicle.pictures[0] : 'assets/images/no-car-image.png'"
            [alt]="invoice.editableVehicle?.make + ' ' + invoice.editableVehicle?.model"
            class="car-image">
        </div>

        <!-- Vehicle Specifications -->
        <div class="vehicle-specs">
          <div class="spec-row">
            <input type="text" class="form-control form-control-sm make-input"
              [(ngModel)]="invoice.editableVehicle.make"
              (ngModelChange)="onFieldChange()">
          </div>

          <div class="spec-row">
            <input type="text" class="form-control form-control-sm model-input"
              [(ngModel)]="invoice.editableVehicle.model"
              (ngModelChange)="onFieldChange()">
          </div>

          <div class="spec-row">
            <span class="spec-label">MFG YEAR:</span>
            <span class="spec-value">
              <input type="text" class="form-control form-control-sm"
                [(ngModel)]="invoice.editableVehicle.year"
                (ngModelChange)="onFieldChange()">
            </span>
          </div>

          <div class="spec-row">
            <span class="spec-label">MODEL CODE:</span>
            <span class="spec-value">
              <input type="text" class="form-control form-control-sm"
                [(ngModel)]="invoice.editableVehicle.body_type"
                (ngModelChange)="onFieldChange()">
            </span>
          </div>

          <div class="spec-row">
            <span class="spec-label">ENGINE:</span>
            <span class="spec-value">
              <input type="text" class="form-control form-control-sm"
                [(ngModel)]="invoice.editableVehicle.engine"
                (ngModelChange)="onFieldChange()"> CC
            </span>
          </div>

          <div class="spec-row">
            <span class="spec-label">MILEAGE:</span>
            <span class="spec-value">
              <input type="number" class="form-control form-control-sm"
                [(ngModel)]="invoice.editableVehicle.mileage"
                (ngModelChange)="onFieldChange()"> KM
            </span>
          </div>
        </div>

        <!-- Additional Vehicle Details -->
        <div class="additional-specs">
          <div class="spec-row">
            <span class="spec-label">STOCK NUMBER:</span>
            <span class="spec-value">
              <input type="text" class="form-control form-control-sm"
                [(ngModel)]="invoice.editableVehicle.stock_no"
                (ngModelChange)="onFieldChange()">
            </span>
          </div>

          <div class="spec-row">
            <span class="spec-label">CHASSIS NO:</span>
            <span class="spec-value">
              <input type="text" class="form-control form-control-sm"
                [(ngModel)]="invoice.editableVehicle.chassis_no"
                (ngModelChange)="onFieldChange()">
            </span>
          </div>

          <div class="spec-row">
            <span class="spec-label">FUEL:</span>
            <span class="spec-value">
              <input type="text" class="form-control form-control-sm"
                [(ngModel)]="invoice.editableVehicle.fuel_type"
                (ngModelChange)="onFieldChange()">
            </span>
          </div>

          <div class="spec-row">
            <span class="spec-label">COLOR:</span>
            <span class="spec-value">
              <input type="text" class="form-control form-control-sm"
                [(ngModel)]="invoice.editableVehicle.exterior_color"
                (ngModelChange)="onFieldChange()">
            </span>
          </div>

          <div class="spec-row">
            <span class="spec-label">TRANS:</span>
            <span class="spec-value">
              <input type="text" class="form-control form-control-sm"
                [(ngModel)]="invoice.editableVehicle.transmission"
                (ngModelChange)="onFieldChange()">
            </span>
          </div>

        </div>

        <!-- Cost Details -->
        <div class="cost-details">
          <div class="cost-row">
            <span class="cost-label">UNIT PRICE & FOB:</span>
            <span class="cost-value">
              {{ invoice.item?.currency || 'USD' }}
              <input type="number" class="form-control form-control-sm d-inline-block"
                style="width: 150px;"
                [(ngModel)]="invoice.editableInvoiceAmount"
                (ngModelChange)="onFieldChange()">
            </span>
          </div>
          <div class="cost-row">
            <span class="cost-label">INSURANCE:</span>
            <span class="cost-value">
              {{ invoice.item?.currency || 'USD' }}
              <input type="number" class="form-control form-control-sm d-inline-block"
                style="width: 150px;"
                [(ngModel)]="invoice.editableInsurance"
                (ngModelChange)="onFieldChange()">
            </span>
          </div>
          <div class="cost-row">
            <span class="cost-label">FREIGHT:</span>
            <span class="cost-value">
              {{ invoice.item?.currency || 'USD' }}
              <input type="number" class="form-control form-control-sm d-inline-block"
                style="width: 150px;"
                [(ngModel)]="invoice.editableFreight"
                (ngModelChange)="onFieldChange()">
            </span>
          </div>
        </div>
      </div>

      <!-- Merged Vehicles Mode -->
      <div class="merged-vehicles-content" *ngIf="viewMode === 'merged' && invoice.editableVehicles">
        <div class="vehicles-table-container">
          <table class="vehicles-table">
            <thead>
              <tr>
                <!-- <th>Invoice #</th> -->
                <th>Image</th>
                <th>Vehicle Details</th>
                <th>Specifications</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let vehicle of invoice.editableVehicles; let idx = index; trackBy: trackByVehicleIndex">
                <!-- <td class="invoice-number">
                  <input type="text" class="form-control form-control-sm"
                    [(ngModel)]="vehicle.invoice_number"
                    (ngModelChange)="onFieldChange()">
                </td> -->
                <td class="vehicle-image-cell">
                  <img
                    [src]="vehicle.pictures && vehicle.pictures.length > 0 ? vehicle.pictures[0] : 'assets/images/no-car-image.png'"
                    [alt]="vehicle.make + ' ' + vehicle.model"
                    class="merged-car-image">
                </td>
                <td class="vehicle-details">
                  <div class="vehicle-name">
                    <input type="text" class="form-control form-control-sm"
                      [(ngModel)]="vehicle.make"
                      (ngModelChange)="onFieldChange()">
                    <input type="text" class="form-control form-control-sm mt-1"
                      [(ngModel)]="vehicle.model"
                      (ngModelChange)="onFieldChange()">
                  </div>
                  <div class="vehicle-year">
                    Year:
                    <input type="text" class="form-control form-control-sm d-inline-block"
                      style="width: 80px;"
                      [(ngModel)]="vehicle.year"
                      (ngModelChange)="onFieldChange()">
                  </div>
                  <div class="vehicle-chassis">
                    Chassis:
                    <input type="text" class="form-control form-control-sm d-inline-block"
                      style="width: 150px;"
                      [(ngModel)]="vehicle.chassis_no"
                      (ngModelChange)="onFieldChange()">
                  </div>
                  <div class="vehicle-stock">
                    Stock:
                    <input type="text" class="form-control form-control-sm d-inline-block"
                      style="width: 120px;"
                      [(ngModel)]="vehicle.stock_no"
                      (ngModelChange)="onFieldChange()">
                  </div>
                </td>
                <td class="vehicle-specs">
                  <div class="spec-item">
                    Engine:
                    <input type="text" class="form-control form-control-sm d-inline-block"
                      style="width: 80px;"
                      [(ngModel)]="vehicle.engine"
                      (ngModelChange)="onFieldChange()"> CC
                  </div>
                  <div class="spec-item">
                    Mileage:
                    <input type="number" class="form-control form-control-sm d-inline-block"
                      style="width: 100px;"
                      [(ngModel)]="vehicle.mileage"
                      (ngModelChange)="onFieldChange()"> KM
                  </div>
                  <div class="spec-item">
                    Fuel:
                    <input type="text" class="form-control form-control-sm d-inline-block"
                      style="width: 100px;"
                      [(ngModel)]="vehicle.fuel_type"
                      (ngModelChange)="onFieldChange()">
                  </div>
                  <div class="spec-item">
                    Color:
                    <input type="text" class="form-control form-control-sm d-inline-block"
                      style="width: 100px;"
                      [(ngModel)]="vehicle.exterior_color"
                      (ngModelChange)="onFieldChange()">
                  </div>
                  <div class="spec-item">
                    Trans:
                    <input type="text" class="form-control form-control-sm d-inline-block"
                      style="width: 100px;"
                      [(ngModel)]="vehicle.transmission"
                      (ngModelChange)="onFieldChange()">
                  </div>
                </td>
                <td class="vehicle-amount">
                  <div>
                    <small class="cost-sub-label">UNIT PRICE:</small><br>
                    {{ vehicle.item?.currency || 'USD' }}
                    <input type="number" class="form-control form-control-sm"
                      [(ngModel)]="vehicle.invoice_amount"
                      (ngModelChange)="onFieldChange()">
                  </div>
                  <div class="mt-1">
                    <small class="cost-sub-label">INSURANCE:</small><br>
                    {{ vehicle.item?.currency || 'USD' }}
                    <input type="number" class="form-control form-control-sm"
                      [(ngModel)]="vehicle.insurance"
                      (ngModelChange)="onFieldChange()">
                  </div>
                  <div class="mt-1">
                    <small class="cost-sub-label">FREIGHT:</small><br>
                    {{ vehicle.item?.currency || 'USD' }}
                    <input type="number" class="form-control form-control-sm"
                      [(ngModel)]="vehicle.freight"
                      (ngModelChange)="onFieldChange()">
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Total Section -->
      <div class="total-section">
        <div class="total-row">
          <span class="total-label">TOTAL {{ viewMode === 'merged' && invoice.editableVehicles ? invoice.editableVehicles.length : 1 }} UNIT(S)</span>
          <span class="total-value">
            TOTAL C&F: <strong>{{ invoice.item?.currency || 'USD' }} {{ getInvoiceTotal(invoice) | number:'1.2-2' }}</strong>
          </span>
        </div>
      </div>
    </div>

    <!-- Footer Section -->
    <div class="invoice-footer">
      <div class="due-date-section">
        <div class="due-date">
          <span class="label">DUE DATE *</span>
        </div>
      </div>

      <div class="notes-section">
        <div class="notes-header">NOTES:</div>
        <div class="notes-content">
          <p>PLEASE INCLUDE PROFORMA NUMBERS IN THE REMITTANCE INFORMATION SECTION WHEN
          MAKING YOUR PAYMENT WE CERTIFY THAT THE GOODS ARE OF JAPANESE ORIGIN THE
          BUYER SHOULD BEAR THE COST OF BANK CHARGE WHEN REMITTING T/T. THE BUYER IS
          PURCHASING A RECONDITIONED VEHICLE MINOR ISSUES SUCH AS WEAK BATTERY, LACK
          OF COOLANT, MINOR SCRATCHES, DENTS, WORN TIRES, MINOR ELECTRICAL ISSUES
          OR THE TRANSPORT COMPARTMENT BEFORE MOVING THE VEHICLE FROM PORT TO THE
          FINAL DESTINATION.</p>
        </div>
      </div>

      <div class="signature-section">
        <div class="authorized-signature">
          <p><strong>AUTHORIZED SIGNATURE</strong></p>
          <div class="signature-line">
            <p><strong>Imperial Solutions</strong></p>
            <p><strong>D.S SETHI</strong></p>
          </div>
        </div>
      </div>
    </div>

    <!-- Page Break (except for last invoice) -->
    <div class="page-break" *ngIf="i < invoices.length - 1"></div>

  </div>
</div>
